import { initCore } from 'src/lib/init.js'
import renderComponents from 'src/lib/render-components.js'
import Collection from '@/collection/Collection.vue'

initCore()
renderComponents({'collection': Collection})
